import { LayerCache } from '../../LayerCache.js';
import { Folder } from '../../layer/Folder.js';
import { IndexBinder } from './IndexBinder.js';

export { OgcBinder };

/**
 * Class with static functions to load WMS and WFS Capabilities
 * @memberof vef.map.importer.binder
 */
class OgcBinder {

    /**
     * @private
     * @param {string} response 
     * @returns {object} layers
     */
    static async createLayers_(response) {
        try {
            const json = JSON.parse(response);
            const folder = new Folder({ title: json.service.title })
            const layers = {}
            const structure = { "#": [folder.uniqueId] }
            layers[folder.uniqueId] = folder;
            structure[folder.uniqueId] = []

            for (let l in json.layers) {
                json.layers[l].resources.push(json.link, json.service);
                json.layers[l] = await IndexBinder.fixRecord_(json.layers[l]);
                const config = IndexBinder.createLayer(json.layers[l]);
                const layer = LayerCache.loadLayer({}, config);
                layers[layer.uniqueId] = layer;
                structure[folder.uniqueId].push(layer.uniqueId)
            }

            return {
                layers: layers,
                structure: structure
            }
        } catch (e) { }
        return null;
    }

    /**
     * Creates WMSLayers from a URL and parses the GetCapabilitites
     * 
     * @param {string} parserUrl
     * @param {string} url
     * @param {string} type (optional)
     * 
     * @returns {object} object with layers and structure
     */
    static getCapabilities(parserUrl, serviceUrl, type) {
        parserUrl = parserUrl || "https://marine-data.de/tools/ogccapabilities";
        serviceUrl = encodeURIComponent(serviceUrl.split("?")[0].trim())

        const promises = [];
        const types = ["wms", "wfs"]

        for (let t of types) {
            if (type && (type.toLowerCase() != t)) continue;
            promises.push(new Promise((resolve, reject) => {
                const xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = () => {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            this.createLayers_(xhttp.responseText).then(layers => {
                                resolve(layers);
                            }).catch(e => resolve(null));
                        } else {
                            resolve(null);
                        }
                    }
                };
                xhttp.open("GET", `${parserUrl}?url=${serviceUrl}&type=${t}`, true);
                xhttp.send();
            }));
        }

        return new Promise(resolve => {
            Promise.all(promises).then((data) => {
                resolve(data);
            });
        });

    }

}